import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getSubmittedTrustdockData } from '@src/api'
import {
  DefaultApiGetSubmittedTrustdockDataRequest,
  GetSubmittedTrustdockData200Response,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchSubmittedTrustdockData = (
  params: DefaultApiGetSubmittedTrustdockDataRequest
) => {
  const { axiosInstance } = useAxios({ shouldSkipLogout: true })

  return useQuery<
    AxiosResponse<GetSubmittedTrustdockData200Response>,
    AxiosResponse<CustomError>
  >({
    enabled: !!params.trustdockIdentificationId,
    queryFn: () => getSubmittedTrustdockData(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_SUBMITTED_TRUSTDOCK_DATA,
      params.trustdockIdentificationId,
    ],
  })
}
